import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Card, Modal, ModalBody, ModalHeader } from 'reactstrap';
import CardTabs from '../../pages/components/cards/CardTabs';
import { RETRIEVE_TENANT_PRODUCT_PRICING_DETAILS_API } from '../../api/api_data';
import { tenant_auth_actions_helper } from '../../actions/actions_helper';
import { fail_retrieve_specific_tenant_product_details, loading_retrieve_specific_tenant_product_details, reset_retrieve_specific_tenant_product_details, success_retrieve_specific_tenant_product_details } from '../../reducers/auth_tenant/retrieve_specific_tenant_product_details_Slice';
import { RETRIVE_SPECIFIC_TENANT_PRODUCT_DETAILS_ERROR_MSG, RETRIVE_SPECIFIC_TENANT_PRODUCT_DETAILS_SUCCESS_MSG } from '../../utils/error_success_messages';
import { useSelector } from 'react-redux';
import { addThreeDots, formatToSentenceCase, messageToast } from '../../utils/Utils';
import * as app_consts from "../../utils/app_consts";
import { Block, BlockBetween, BlockHead, BlockTitle, Button, Col, DataTableBody, DataTableHead, DataTableItem, DataTableRow, Icon, PaginationComponent, Row } from '../Component';
import moment from 'moment';
import UpdateProductPriceModal from './UpdateProductPriceModal';

const ViewProductValueModal = ({ isOpen, closeModal, data, tenant_info, user_info, successFunction }) => {

  const [page_data, setPageData] = useState(data);
  const [open, setOpen] = useState(isOpen);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [retrieved_data, setRetrievedData] = useState([]);
  const dispatch = useDispatch();
  const [activeCardTab, setActiveCardTab] = useState("Main Info");
  const [update_price_modal, setUpdatePriceModal] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(10);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);


  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = retrieved_data?.product_prices?.slice(indexOfFirstItem, indexOfLastItem);


  useEffect(() => {
    if (isOpen)
    {
      retrieve_product_details(data);
    }
    setPageData(data);
    setOpen(isOpen);
  }, [data, isOpen]);

  const retrieve_product_details = (product_id) => {
    setError("");
    // Dispatch
    setLoading(true);
    dispatch(tenant_auth_actions_helper(loading_retrieve_specific_tenant_product_details, success_retrieve_specific_tenant_product_details, fail_retrieve_specific_tenant_product_details, RETRIVE_SPECIFIC_TENANT_PRODUCT_DETAILS_ERROR_MSG, RETRIVE_SPECIFIC_TENANT_PRODUCT_DETAILS_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_TENANT_PRODUCT_PRICING_DETAILS_API}/${product_id}`));
  };

  // Listener
  const retrieve_specific_tenant_product_details_listener = useSelector((state) => state.retrieve_specific_tenant_product_details.retrieve_specific_tenant_product_details);

  useEffect(() => {
    if (retrieve_specific_tenant_product_details_listener.status !== app_consts.IDLE)
    {
      if (retrieve_specific_tenant_product_details_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        if (retrieve_specific_tenant_product_details_listener.status === app_consts.FAIL)
        {
          setLoading(false);
          setError(retrieve_specific_tenant_product_details_listener.message);
          messageToast(retrieve_specific_tenant_product_details_listener.message, app_consts.FAIL);
        } else if (retrieve_specific_tenant_product_details_listener.status === app_consts.SUCCESS)
        {
          setRetrievedData(retrieve_specific_tenant_product_details_listener.data);
          const timer = setTimeout(() => {
            setLoading(false);
          }, 1000);

          return () => clearTimeout(timer); // cleanup in case the component unmounts
        }
        dispatch(reset_retrieve_specific_tenant_product_details());
      }
    }
  }, [retrieve_specific_tenant_product_details_listener]);



  // Card Tabs
  const tabs = [
    {
      tabName: "Main Info"
    },
    {
      tabName: "Pricing History"
    },
  ];

  const open_update_price_modal = () => {
    setUpdatePriceModal(true);
  };

  const close_update_price_modal = () => {
    setUpdatePriceModal(false);
  };

  const updateSuccessFunction = () => {
    retrieve_product_details(page_data?.id);
    setActiveCardTab("Pricing History");
    close_update_price_modal();
    successFunction();
  };

  return (
    <>
      <Modal isOpen={open} toggle={closeModal} className="modal-dialog-centered" size={"xl"}>
        <ModalHeader toggle={closeModal}>Specific Product Value Details</ModalHeader>
        <ModalBody>
          {
            loading ?
              <>
                <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                  <div className="text-soft fw-bold" style={{ fontSize: 24, marginTop: "90px" }}>Retrieveing Product Details...</div>
                  <div className="nk-loader mt-2  w-70 m-auto "></div>
                </div>
              </>
              :
              <>
                {
                  error ?
                    <>
                      <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                        <div className="text-soft fw-bold" style={{ fontSize: 24, marginTop: "90px" }}>{error}</div>
                      </div>
                    </>
                    :
                    <>
                      <Block>
                        <BlockBetween className="mt-4">
                          {(user_info?.roles?.includes(app_consts.ADD_PRODUCT_PRICING) || user_info?.roles?.includes(app_consts.ADMINISTRATOR)) && (
                            <>
                              <Button color="primary" size="sm" onClick={() => open_update_price_modal()}>
                                Update Price
                              </Button>
                            </>
                          )}
                        </BlockBetween>
                        <CardTabs cardTabs={tabs} activeCardTab={activeCardTab} setActiveCardTab={setActiveCardTab} />
                      </Block>
                      <div className='mt-4'>
                      </div>

                      {
                        activeCardTab === "Main Info" && (
                          <div className="card-inner bg-white">
                            <Block>
                              <BlockHead>
                                <BlockTitle tag="h5">Main info</BlockTitle>
                              </BlockHead>
                              <div className="profile-ud-list">
                                <div className="profile-ud-item">
                                  <div className="profile-ud wider">
                                    <span className="profile-ud-label">Product Name</span>
                                    <span className="profile-ud-value">{retrieved_data?.name ? formatToSentenceCase(retrieved_data?.name) : "--"}</span>
                                  </div>
                                </div>
                                <div className="profile-ud-item">
                                  <div className="profile-ud wider">
                                    <span className="profile-ud-label">Brand</span>
                                    <span className="profile-ud-value">{retrieved_data?.category ? formatToSentenceCase(retrieved_data?.category) : "--"}</span>
                                  </div>
                                </div>
                                <div className="profile-ud-item">
                                  <div className="profile-ud wider">
                                    <span className="profile-ud-label">Product Type</span>
                                    <span className="profile-ud-value">{retrieved_data?.product_type ? formatToSentenceCase(retrieved_data?.product_type) : "--"}</span>
                                  </div>
                                </div>
                                <div className="profile-ud-item">
                                  <div className="profile-ud wider">
                                    <span className="profile-ud-label">Current Price</span>
                                    <span className="profile-ud-value">{retrieved_data?.product_value ? `${retrieved_data?.product_value} ZMW` : "--"}</span>
                                  </div>
                                </div>
                              </div>
                            </Block>
                          </div>
                        )
                      }
                      {
                        activeCardTab === "Pricing History" && (
                          <>
                            <div className="card-title my-2">
                              <h4 className="title">Pricing History</h4>
                            </div>
                            <Card>
                              <div className="card-inner-group">
                                <div className="card-inner p-0">
                                  <DataTableBody>
                                    <DataTableHead>
                                      <DataTableRow>
                                        <span>Comment</span>
                                      </DataTableRow>
                                      <DataTableRow size="sm">
                                        <span>Price</span>
                                      </DataTableRow>
                                      <DataTableRow>
                                        <span>Effective Date</span>
                                      </DataTableRow>
                                      <DataTableRow size="md">
                                        <span>Action</span>
                                      </DataTableRow>
                                    </DataTableHead>
                                    {currentItems?.length > 0
                                      ? currentItems.map((item, index) => {

                                        return (
                                          <DataTableItem key={index}>
                                            <DataTableRow size="sm">
                                              <span className="tb-product">
                                                <span className="">
                                                  {item?.adjustment_comment ? addThreeDots(item?.adjustment_comment, 60) : "--"}
                                                </span>
                                              </span>
                                            </DataTableRow>
                                            <DataTableRow>
                                              <span className="tb-sub">{item?.price ? `${item?.price} ZMW` : "0.00"}</span>
                                            </DataTableRow>
                                            <DataTableRow>
                                              <span className="tb-odr-date">
                                                {item?.effective_date ? moment(item?.effective_date).format("YYYY-MM-DD HH:mm:ss") : "--"}
                                              </span>
                                            </DataTableRow>
                                            <DataTableRow className="nk-tb-col-tools">
                                              <div className="tb-odr-btns d-none d-sm-inline">
                                                <Button onClick={(e) => { e.preventDefault(); /* open_view_history_modal(item?.inserted_at); */ }} color="primary" size="sm" className="btn btn-dim">
                                                  View
                                                </Button>
                                              </div>
                                              <Button onClick={(e) => { e.preventDefault(); /* open_view_history_modal(item?.inserted_at); */ }} className="btn-pd-auto d-sm-none">
                                                <Icon name="chevron-right"></Icon>
                                              </Button>
                                            </DataTableRow>
                                          </DataTableItem>
                                        );
                                      })
                                      : null}
                                  </DataTableBody>
                                  <div className="card-inner">
                                    {retrieved_data?.product_prices?.length > 0 ? (
                                      <PaginationComponent
                                        itemPerPage={itemPerPage}
                                        totalItems={retrieved_data?.product_prices?.length}
                                        paginate={paginate}
                                        currentPage={currentPage}
                                      />
                                    ) : (
                                      <div className="text-center">
                                        <span className="text-silent">No Products Pricing History found</span>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </Card>
                          </>
                        )
                      }
                    </>
                }
              </>
          }
          <UpdateProductPriceModal isOpen={update_price_modal} closeModal={close_update_price_modal} data={retrieved_data} successFunction={updateSuccessFunction} tenant_info={tenant_info} user_info={user_info} />
        </ModalBody>
      </Modal>
    </>
  );
};

export default ViewProductValueModal;